import {Component, OnInit} from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-usa',
  templateUrl: './usa.component.html',
  styleUrls: ['./usa.component.scss']
})
export class UsaComponent implements OnInit {
  productName = environment.programName;
  androidStoreURL: string = environment.androidStore;
  iosStoreURL: string = environment.iosStore;
  referredCodeParam: string;

  constructor(public platform: Platform, protected router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    const brokerCode: string = this.route.snapshot.queryParamMap.get('brokerCode');
    this.referredCodeParam = brokerCode;
    const externalReferenceCode: string = this.route.snapshot.queryParamMap.get('externalReferenceCode');
    let storeAndroidLink = '';
    let dataReferredCode: string = null;
    let dataExternalReferenceCode: string = null;

    if (brokerCode !== null && brokerCode !== '') {
      dataReferredCode = `brokerCode%3D${brokerCode}`;
    }

    if (externalReferenceCode !== null && externalReferenceCode !== '') {
      dataExternalReferenceCode = `externalReferenceCode%3D${externalReferenceCode}`;
    }

    if (brokerCode !== null || externalReferenceCode !== null) {
      storeAndroidLink = `&referrer=${dataReferredCode ?? ''}${dataReferredCode !== null && dataExternalReferenceCode != null ? '%26' : ''}${dataExternalReferenceCode ?? ''}`;
    }

    this.androidStoreURL = `${this.androidStoreURL}${storeAndroidLink}`;

    if (this.platform.IOS) {
      // window.location.href = `${environment.iosStore}`;
      window.location.href = this.iosStoreURL;
    }
    if (this.platform.ANDROID) {
      // window.location.href = `${environment.androidStore}${storeAndroidLink}`;
      window.location.href = this.androidStoreURL;
    }
    // if (!this.platform.IOS && !this.platform.ANDROID) {
    //   this.router.navigateByUrl('/');
    // }
  }


}
